import React from "react";
import { shallowEqual, useSelector } from "react-redux";
// hooks
import useContent from "@/hooks/useContent";
// components
import RMDRImage from "@/components/RMDRImage";
import RMDRLink from "@/components/RMDRLink";
// utilities
import { outerNameDescriptionLanguageVersion } from "@/utilities/LanguageVersionSelectorShortcut";
// type
import { TMainPageLayoutV3 } from "../type";
// enums
import EResourceType from "@/cms/enums/EResourceType";
import ESizeType from "@/cms/enums/ESizeType";
// interfaces
import TClientContentDetail from "@/cms/types/TClientContentDetail";
import TClientPageDetail from "@/cms/types/TClientPageDetail";
import TClientMainPageItemList from "@/cms/types/TClientMainPageItemList";


type TMNPG048 = {
    contentDetails:TClientContentDetail|TClientPageDetail|null;
}

const Render = ( props:{ contentDetails:TClientContentDetail|TClientPageDetail|null, template: TClientMainPageItemList} ) => {

    const webApplicationLanguageISOCode = useSelector((state:any) => state.CoreStore.languageCode?.payload, shallowEqual);

    if ( !props.contentDetails ) return null;

    const languageVersion = outerNameDescriptionLanguageVersion(props.contentDetails.languageVersions);

    return (
        <RMDRLink
            text={null}
            title={languageVersion?.name}
            hasNavigationDestination={props.template.hasDestinationNavigation}
            navigationURL={`/${webApplicationLanguageISOCode}`}
            redirectType={props.template?.redirectType}
            className="navbar-brand"
            isShowAlways={true}
        >
            <RMDRImage
                resourceType={EResourceType.LOGO_WITH_BOTTOM_TEXT} 
                resources={props.template?.resources} 
                sizeType={ESizeType.X06}
                alt={languageVersion?.name} 
                title={languageVersion?.name}
                className="logo-light"
            />
            <RMDRImage
                resourceType={EResourceType.LOGO_DEFAULT} 
                resources={props.template?.resources} 
                sizeType={ESizeType.X06}
                alt={languageVersion?.name} 
                title={languageVersion?.name}
                className="logo-dark"
            />
        </RMDRLink>
    )
}

const RenderOwnContent = ( props:{unqKey:string, contentId:string, template: TClientMainPageItemList} ) => {
    
    const contentDetails = useContent({unqKey:`${props.unqKey}CD`, id:props.contentId});
    return <Render contentDetails={contentDetails} template={props.template} />

}
const MNPG048 = ( props: TMainPageLayoutV3<TMNPG048> ) => {
    console.log("MNPG048.rendered: ", props);

    if ( !props.template ) return null;

    const unqKey = props.template.id.split("-")[4];
    return <RenderOwnContent unqKey={unqKey} contentId={props.template.contentId} template={props.template} />
}

const Component = React.memo(MNPG048, ( prevProps:TMainPageLayoutV3<TMNPG048>, nextProps:TMainPageLayoutV3<TMNPG048> ) => {
    return true;
});

export default Component;
